var moduleName = 'services.registration';

/**
 * Register a new user
 */
class RegistrationService {
    /**
     * Init
     * @param $http
     */
    constructor($http) {
        this.http = $http;
    }

    /**
     * Check Username is Unique on server
     * @returns {*}
     */
    checkUserName(username) {
        //TODO PLaceholder only
    }

    /**
     * Create new user
     * @returns {*}
     */
    createPharmacist(pharmacist,handleSuccess, handleError) {
        this.http.post('/app/register', {
            pharmacist: pharmacist
        }).then(handleSuccess, handleError);

    }

    /**
     * Verify PA account
     * @returns {*}
     */
    verifyPharmacist(code,pharmacist,handleSuccess, handleError) {
        this.http.post('/app/complete', {
            pharmacist: pharmacist,
            code: code
        }).then(handleSuccess, handleError);

    }

    /**
     * Send the email allowing the user to reset their password
     * @param {String}      email
     * @param {String}      mrnNumber
     * @param {Function}    handleSuccess
     * @param {Function}    handleError
     */
    sendResetEmailPassword(email, mrnNumber, handleSuccess, handleError) {
        return this.http.post('/app/sendResetEmail', {
            email:          email,
            mrnNumber: mrnNumber
        }).then(handleSuccess, handleError);
    }

    /**
     * Set the new password as password for the designation account
     * @param {String}      hash
     * @param {String}      password
     * @param {Function}    handleSuccess
     * @param {Function}    handleError
     */
    resetPassword(hash, password, handleSuccess, handleError) {
        return this.http.post('/app/reset_password', {
            hash:       hash,
            password:   password
        }).then(handleSuccess, handleError);
    }

}

/**
 * Dependencies
 */
RegistrationService.$inject = ['$http'];


/**
 * Add to angular and make available
 */
export default angular.module(moduleName, [])
    .service('RegistrationService', RegistrationService)
    .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/registration.service.js
 **/